import React from 'react'

import { motion } from 'framer-motion'

import Card from '@src/components/Card'

export const Rules: React.FC = () => {
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { staggerChildren: 0.1 },
        },
    }

    const item = {
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0 },
    }

    return (
        <Card>
            <motion.div variants={container} initial='hidden' animate='show' className='space-y-4'>
                <div className='relative'>
                    <h2 className='pb-4 text-center text-3xl font-bold'>Mach Miles Rules</h2>
                </div>

                <motion.div className='space-y-3 rounded-lg bg-black/25 p-6'>
                    <motion.div variants={item} className='rule-card'>
                        <div className='flex items-center gap-3'>
                            <span className='text-xl'>💰</span>
                            <div>
                                <h3 className='font-medium text-white'>Daily Swapping Miles</h3>
                                <p className='text-sm text-gray-400'>1,000 bonus Miles each day you place a trade</p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div variants={item} className='rule-card'>
                        <div className='flex items-center gap-3'>
                            <span className='text-xl'>✨</span>
                            <div>
                                <h3 className='font-medium text-white'>Swap Multipliers</h3>
                                <p className='text-sm text-gray-400'>3x Miles for non-stable routes</p>
                                <p className='text-sm text-gray-400'>
                                    5x Miles for emerging routes like Solana, Unichain, and more
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div variants={item} className='rule-card'>
                        <div className='flex items-center gap-3'>
                            <span className='text-xl'>🚀</span>
                            <div>
                                <h3 className='font-medium text-white'>Volume Miles</h3>
                                <p className='text-sm text-gray-400'>1 Mile per $1 traded (up to 1mm/week)</p>
                                <p className='text-sm text-gray-400'>
                                    Cross-asset, non-stable swaps earn 50% more miles
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div variants={item} className='rule-card'>
                        <div className='flex items-center gap-3'>
                            <span className='text-xl'>👥</span>
                            <div>
                                <h3 className='font-medium text-white'>Referral Program</h3>
                                <p className='text-sm text-gray-400'>
                                    Once you earn 10k Miles, you unlock your referral code. Share this code to earn a
                                    portion of your friends' volume miles and give them a 15% volume miles boost
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
        </Card>
    )
}
